import fetch from "auth/FetchInterceptor";
const PaymentService = {};

const paymentEndpointPrefix = "/payment";

PaymentService.getPayments = async (studentFormationName) =>
  await fetch(
    `${paymentEndpointPrefix}/getAll?studentFormationName=${studentFormationName}`,
    { method: "GET" }
  );

PaymentService.updatePayment = async ({ paymentId, newPayment }) =>
  await fetch(`${paymentEndpointPrefix}/update/${paymentId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: { payment: newPayment },
  });
PaymentService.pay = async ({ paymentId, newPayment }) =>
  await fetch(`${paymentEndpointPrefix}/pay/${paymentId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: { payment: newPayment },
  });

PaymentService.removeDiscount = async (paymentId) =>
  await fetch(`${paymentEndpointPrefix}/removeDiscount/${paymentId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  });

PaymentService.editPaymentHistory = async ({ paymentId, historyId, data }) =>
  await fetch(`${paymentEndpointPrefix}/${paymentId}/history/${historyId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
PaymentService.deletePaymentHistory = async ({ paymentId, historyId }) =>
  await fetch(`${paymentEndpointPrefix}/${paymentId}/history/${historyId}`, {
    method: "DELETE",
  });

export default PaymentService;
